<template>
	<div data-test="document-link-list" class="vcx-grid vcx-gap-100">
		<VcxLiteratureLinkItem
			v-for="literature in props.literatureList"
			:key="literature.title"
			class="vcx-col-12 vcx-col-6-md"
			:literature="literature"
		/>
	</div>
</template>

<script setup lang="ts">
import { FundLiterature } from 'types/funds';
import VcxLiteratureLinkItem from '@components/vcx/vcx-literature-link-item.vue';

interface Props {
	literatureList: Array<FundLiterature>;
}

const props = defineProps<Props>();
</script>
